import classnames from 'classnames';
import React, { ReactElement, useEffect, useState } from 'react';

const MainWrapper = ({
  children,
  isReady,
}: {
  children: ReactElement;
  isReady: boolean;
}) => {
  // Added the {isReady} prop to create a wait flag in those components that are
  // asynchronous and generate an alert in the browser when rendering unmounted children.
  const [hide, setHide] = useState(!isReady);
  useEffect(() => {
    // Timeout to prevent a flicker while downloading fonts and styles when refreshing the page
    setTimeout(() => {
      setHide(!isReady);
    }, 500);
  }, []);
  return (
    <div className={classnames({ hide }, 'w-auto h-100 min-h-100')}>
      {children}
    </div>
  );
};

export default MainWrapper;
